import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import orderApi from '../../../api/services/OrderApi'
import {
  AmountInfo,
  fetchStatusIs,
  LocationConfig,
  PaymentInfo,
  PaymentStatus,
  RequestStatus,
} from '../../../api/types'
import AppSpinner from '../../../components/AppSpinner'
import MainLayout from '../../../shared/layout/main-layout/MainLayout'
import AppContext from '../../context'
import {
  setAmount,
  setLocationConfig,
  setPaymentInfo,
  setSelectedGoal,
  setSelectedOrganization,
} from '../../context/actions'
import NavbarContext from '../../navbar/context'
import {
  setClosePathname,
  setIsBackButtonVisible,
  setIsCloseButtonVisible,
} from '../../navbar/context/action'
import FailedTransactionView from './FailedTransactionView'

export type FailedTransactionParamsType = {
  orderId: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface FailedTransactionProps {}

const FailedTransaction = ({}: FailedTransactionProps) => {
  const { state, contextDispatch } = useContext(AppContext)
  const { contextDispatch: navbarContextDispatch } = useContext(NavbarContext)

  const [searchParams] = useSearchParams()

  const orderId = searchParams.get('orderId')
  const paymentStatus = searchParams.get('paymentStatus')

  const [requestStatus, setRequestStatus] = useState<RequestStatus>(
    RequestStatus.Idle
  )
  const { idle, pending, fulfilled } = fetchStatusIs(requestStatus)

  const navigate = useNavigate()

  useEffect(() => {
    setClosePathname(
      navbarContextDispatch,
      `/${state.locationConfig?.locationCode}`
    )
    setIsBackButtonVisible(navbarContextDispatch, false)
    setIsCloseButtonVisible(navbarContextDispatch, true)
  }, [state.locationConfig])

  useEffect(() => {
    if (paymentStatus) {
      const data: PaymentInfo = {
        status: PaymentStatus[paymentStatus as keyof typeof PaymentStatus],
      }
      setPaymentInfo(contextDispatch, data)
    }
  }, [])

  const fetch = useCallback(async () => {
    if (!orderId) return
    setRequestStatus(RequestStatus.Pending)
    const result = await orderApi.getOrder(orderId)
    if (result) {
      setSelectedGoal(contextDispatch, result.data.goal)
      setSelectedOrganization(contextDispatch, result.data.organization)

      const amount: AmountInfo = {
        value: Number(result.data.amount / 100).toString(),
        txt: `${Number(result.data.amount / 100)} zł`,
      }

      setAmount(contextDispatch, amount)

      const data: LocationConfig = {
        logoId: result.data.logoId,
        backgroundId: result.data.backgroundId,
        locationCode: result.data.locationCode,
      }
      setLocationConfig(contextDispatch, data)

      setRequestStatus(RequestStatus.Fulfilled)
    } else {
      setRequestStatus(RequestStatus.Rejected)
    }
  }, [contextDispatch])

  useEffect(() => {
    if (idle) fetch()
  }, [fetch, idle])

  if (!orderId) {
    navigate('/blad')
    return null
  }

  return (
    <>
      <MainLayout withSideImage withNavbar withoutDecorations>
        <AppSpinner show={pending} />
        {fulfilled && <FailedTransactionView />}
      </MainLayout>
    </>
  )
}

export default FailedTransaction
